import { DEMO_PROJECT_ID, startDemo } from '../demo';
import { h } from '../dom';
import { L, t } from '../i18n';
import { createMap, type MapHandles } from '../map';
import { toHash } from '../router';
import { sendMagicLink } from '../session';
import { backendConfigured } from '../supabase';
import type { View } from './project';
import { button, card, errorBox, input, labelled } from './shared';

/** Sign-in screen. Shows the site map underneath so the page is useful before any data exists. */
export function authView(): View {
  const email = input({ type: 'email', autocomplete: 'email', placeholder: 'name@school.org', required: true, disabled: !backendConfigured });
  const status = h('p', { class: 'hint' });
  const form = h(
    'form',
    {
      class: 'form',
      onsubmit: async (e: Event) => {
        e.preventDefault();
        status.replaceChildren();
        try {
          await sendMagicLink(email.value.trim());
          status.textContent = t('auth.link_sent');
        } catch (err) {
          status.replaceChildren(errorBox(err));
        }
      },
    },
    labelled(t('auth.email'), email, t('auth.staff_hint')),
    h('button', { type: 'submit', class: 'btn btn-primary', disabled: !backendConfigured }, t('auth.send_link')),
    status,
  );
  const mapEl = h('div', { class: 'map', id: 'map' });
  const el = h(
    'div',
    { class: 'auth-page' },
    h(
      'div',
      { class: 'auth' },
      card(t('auth.staff_title'), form),
      card(t('auth.team_title'), h('p', null, t('auth.privacy_note')), h('p', { class: 'hint' }, L('Los equipos usan la app del teléfono con su código de equipo.', 'Teams use the phone app with their team code.'))),
      card(
        t('auth.demo_title'),
        h('p', null, L('Un proyecto TEST sintético con 18 árboles y dos monitoreos, solo lectura, para ver el panel antes de que exista el servidor.', 'A synthetic TEST project with 18 trees and two surveys, read only, to see the dashboard before the backend exists.')),
        button(
          t('auth.demo_start'),
          () => {
            startDemo();
            location.hash = toHash({ name: 'project', id: DEMO_PROJECT_ID });
          },
          'btn btn-secondary',
        ),
      ),
    ),
    card(null, mapEl),
  );
  let handles: MapHandles | null = null;
  queueMicrotask(() => {
    try {
      handles = createMap(mapEl, 'satellite');
    } catch (err) {
      mapEl.replaceChildren(errorBox(err));
    }
  });
  return { el, destroy: () => handles?.destroy() };
}

export function signInButton(onClick: () => void): HTMLElement {
  return button(t('auth.title'), onClick, 'btn btn-ghost');
}
